export default "__VITE_ASSET__ceb13e22__"